import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'auto',
      msOverflowY: 'auto',
      width: '100%',
      "& li[type='15']": {
        pointerEvents: 'none',
        opacity: 0.6,
      },
      "& li[type='25']": {
        pointerEvents: 'none',
        opacity: 0.6,
      },
    },
    addIcon: {
      position: 'absolute',
      right: '0',
      marginRight: '30px',
    },
    nodesStylesParent: {
      fontWeight: 400,
      height: 35,
      alignItems: 'center',
      display: 'flex',
    },
    nodeStylesChildren: {
      fontWeight: 400,
      letterSpacing: '0.5px',
      maxWidth: '80%',
      color: 'rgba(255, 255, 255, 0.87)',
      display: 'inline-block',
      wordBreak: 'break-word',
    },
    sideIcon: {
      marginLeft: '10px',
      color: 'white',
      position: 'absolute',
    },
    treeViewData: {
      padding: '8px 0px 0px 16px',
    },
    treeCheck: {
      width: 14,
      height: 14,
      color: 'rgba(255, 255, 255, 0.87)',
    },
  }),
);

export default useStyles;
